/** Read setup acknowledgements as they arrive, keeping their request indexes.
 * JSON remains supported for preflight/auth rejections and legacy responses.
 * The caller retains onResult rows even if the stream times out or disconnects.
 */
export async function readOrderBatchResponse(response, onResult = () => {}) {
  if (!response.headers?.get?.('content-type')?.includes('application/x-ndjson')) {
    return response.json()
  }
  const reader = response.body.getReader()
  const decoder = new TextDecoder()
  let buffer = ''
  let complete = null
  const acceptLine = (line) => {
    if (!line.trim()) return
    const event = JSON.parse(line)
    if (event.type === 'result' && Number.isInteger(event.index) && event.index >= 0 && event.result) {
      onResult(event.index, event.result)
    }
    if (event.type === 'complete') complete = event
  }
  try {
    while (true) {
      const { done, value } = await reader.read()
      buffer += done ? decoder.decode() : decoder.decode(value, { stream: true })
      let newline
      while ((newline = buffer.indexOf('\n')) !== -1) {
        acceptLine(buffer.slice(0, newline))
        buffer = buffer.slice(newline + 1)
      }
      if (done) break
    }
    acceptLine(buffer)
    if (!complete) throw new Error('Order response interrupted — verify broker state before retrying')
    return complete
  } finally {
    reader.releaseLock()
  }
}
